import React, { useEffect, useState } from "react";

const globalStyles = `
body, html {
  margin: 0;
  padding: 0;
  font-family: sans-serif;
  background-color: #fff;
}
.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.main-content {
  flex: 1;
  width: 90%;
  max-width: 1200px;
  margin: 20px auto;
  padding: 0 20px;
}
.seminar-card {
  margin-bottom: 20px;
  padding: 15px 20px;
  border-radius: 10px;
  border: 1px solid #ccc;
  width: calc(100% - 200px);
  margin-left: 200px;
}
.seminar-past { opacity: 0.45; }
.seminar-title { font-size: 1.3rem; font-weight: bold; }
.seminar-datetime { font-size: 0.9rem; }
.seminar-speakers { font-size: 1.2rem; }
.current-title { font-size: 2.8rem; font-weight: bold; }
.upcoming-title { font-size: 1.9rem; }
.seminar-actions { margin-top: 10px; display: flex; gap: 10px; }
.edit-btn { background:#aed3ee; color:#fff; border:none; padding:6px 10px; border-radius:5px; }
.delete-btn { background:#dc3545; color:#fff; border:none; padding:6px 10px; border-radius:5px; }
.submit-btn { background:#000; color:#fff; padding:10px; border:none; border-radius:8px; }
.footer-btn { background:none; border:none; color:gray; text-decoration:underline; cursor:pointer; margin-top: auto; }
.admin-form { display: flex; flex-direction: column; gap: 10px; margin-bottom: 30px; width: 100%; }
.admin-form input { padding: 8px; border-radius: 8px; border: 1px solid #ccc; font-size: 1rem; width: 100%; }
.datetime-row, .speakers-row { display: flex; gap: 10px; width: 100%; }
.datetime-row input, .speakers-row input { flex: 1; }
`;

const AJAX_URL = "/wp-admin/admin-ajax.php";

const parseDateTime = (d, t) => {
  const [y, m, day] = d.split("-").map(Number);
  const [h, min] = t.split(":").map(Number);
  return new Date(y, m - 1, day, h, min);
};

const formatDateCZ = d => {
  const [y, m, day] = d.split("-");
  return `${day}.${m}.${y}`;
};

export default function App() {
  const [seminars, setSeminars] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [adminMode, setAdminMode] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  const [form, setForm] = useState({
    title: "",
    location: "čítárna B1",
    date: "",
    startTime: "13:00",
    endTime: "14:00",
    speaker1: "",
    speaker2: ""
  });

  useEffect(() => {
    const s = document.createElement("style");
    s.innerHTML = globalStyles;
    document.head.appendChild(s);
    return () => document.head.removeChild(s);
  }, []);

  useEffect(() => {
    fetch(`${AJAX_URL}?action=get_seminars`)
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) setSeminars(data);
        setLoaded(true);
      });
  }, []);

  useEffect(() => {
    if (!loaded) return;
    fetch(`${AJAX_URL}?action=save_seminars`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(seminars)
    });
  }, [seminars, loaded]);

  const handleSubmit = e => {
    e.preventDefault();
    if (!form.title || !form.date || !form.speaker1) return;

    setSeminars(prev => {
      const copy = [...prev];
      if (editIndex !== null) copy[editIndex] = form;
      else copy.push(form);
      return copy;
    });

    setForm({ ...form, title: "", speaker1: "", speaker2: "" });
    setEditIndex(null);
  };

  const today = new Date();
  today.setHours(0,0,0,0);

  const sorted = [...seminars].sort((a, b) => parseDateTime(a.date, a.startTime) - parseDateTime(b.date, b.startTime));

  const current = sorted.filter(s => {
    const d = new Date(s.date);
    d.setHours(0,0,0,0);
    return d.getTime() === today.getTime();
  });

  const upcoming = sorted.filter(s => {
    const d = new Date(s.date);
    d.setHours(0,0,0,0);
    return d.getTime() > today.getTime();
  });

  const past = sorted.filter(s => {
    const d = new Date(s.date);
    d.setHours(0,0,0,0);
    return d.getTime() < today.getTime();
  });

  const Card = ({ s, i, past }) => (
    <div className={`seminar-card ${past ? "seminar-past" : ""}`}>
      <div className="seminar-title">{s.title}</div>
      <div className="seminar-datetime">{formatDateCZ(s.date)} {s.startTime}–{s.endTime}, {s.location}</div>
      <div className="seminar-speakers">{s.speaker1}{s.speaker2 && `, ${s.speaker2}`}</div>
      {adminMode && (
        <div className="seminar-actions">
          <button className="edit-btn" onClick={() => { setForm(s); setEditIndex(i); }}>Upravit</button>
          <button className="delete-btn" onClick={() => {
            const d = new Date(s.date); d.setHours(0,0,0,0);
            if (d.getTime() < today.getTime()) {
              if (!window.confirm('Tento seminář je minulý. Opravdu chcete smazat?')) return;
            }
            setSeminars(p => p.filter((_, x) => x !== i));
          }}>Smazat</button>
        </div>
      )}
    </div>
  );

  return (
    <div className="app-container">
      <div className="main-content" style={{ display: "flex", flexDirection: "column", minHeight: "calc(100vh - 20px)" }}>
        {adminMode && (
          <form className="admin-form" onSubmit={handleSubmit}>
            <input placeholder="Název" value={form.title} onChange={e => setForm({ ...form, title: e.target.value })} />
            <input placeholder="Místo" value={form.location} onChange={e => setForm({ ...form, location: e.target.value })} />
            <div className="datetime-row">
              <input type="date" value={form.date} onChange={e => setForm({ ...form, date: e.target.value })} />
              <input type="time" value={form.startTime} onChange={e => setForm({ ...form, startTime: e.target.value })} />
              <input type="time" value={form.endTime} onChange={e => setForm({ ...form, endTime: e.target.value })} />
            </div>
            <div className="speakers-row">
              <input placeholder="Přednášející" value={form.speaker1} onChange={e => setForm({ ...form, speaker1: e.target.value })} />
              <input placeholder="Další" value={form.speaker2} onChange={e => setForm({ ...form, speaker2: e.target.value })} />
            </div>
            <button className="submit-btn">{editIndex !== null ? "Upravit seminář" : "Přidat seminář"}</button>
          </form>
        )}

        <h2 className="current-title">Aktuální semináře</h2>
        {current.length === 0 && <div style={{ fontSize: "0.9rem", color: "#666" }}>Dnes se žádný seminář nekoná</div>}
        {current.map((s, i) => <Card key={i} s={s} i={i} />)}

        <h2 className="upcoming-title">Nadcházející semináře</h2>
        {upcoming.map((s, i) => <Card key={i} s={s} i={i} />)}

        {adminMode && past.length > 0 && (
          <>
            <h2 className="upcoming-title">Minulé semináře</h2>
            {past.map((s, i) => <Card key={i} s={s} i={i} past />)}
          </>
        )}
      </div>
      <div style={{ marginTop: "auto", padding: "20px" }}>
        <button className="footer-btn" onClick={() => setAdminMode(a => !a)}>
          {adminMode ? "Skrýt administraci" : "Přejít do administrace"}
        </button>
      </div>
    </div>
  );
}
